import React ,{ useEffect, useState} from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { useNavigate, Link } from "react-router-dom";
import { stringify } from "querystring";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from 'react-helmet';
import './payment_cancelled.css';

type SeoContent = {
  meta_title: string;
  meta_description?: string;
  // Add more fields as needed
};

const PaymentCancelled: React.FC = () => {

    const dispatch = useDispatch<any>();
    const [soeContent, setSoeContent] = useState<SeoContent | null>(null);

  return (
    <>
    <Helmet>
      <title>{`${soeContent?.meta_title || 'Order Cancelled'}`}</title>
      <meta name="title" content={soeContent?.meta_title || 'E-learning Platform'} />
      <meta name="description" content={soeContent?.meta_description || 'Learn with curated e-learning resources'} />
      <meta name="keywords" content="e-learning, tech-cards, cheat-sheets, tutorials" />
    </Helmet>

      <Header />

        <div className="cancellation-wrapper">
          <div className="cancellation-card">
            <div className="cancellation-header">
              <div className="cancellation-icon">
                <i className="bi bi-x-circle"></i>
              </div>
              <h2 className="fw-bold mb-2">Payment Cancelled</h2>
              <p className="mb-0">Your transaction was not completed</p>
            </div>
            
            <div className="cancellation-body">
              <h4 className="fw-bold mb-3">Your payment was cancelled</h4>
              <p className="text-muted mb-4">No charges have been made to your account.</p>
              
              <div className="info-box">
                <i className="bi bi-info-circle text-primary mb-2" style={{fontSize: '24px'}}></i>
                <p className="mb-0">If this was a mistake, you can try again or contact our support team for assistance.</p>
              </div>

              <div className="mt-4">
                <Link to="/cart" className="btn btn-primary" style={{"width":"30%"}} ><i className="bi bi-arrow-repeat me-2"></i>Try Again</Link>
                <Link to="/dashboard" className="btn btn-outline-primary"><i className="bi bi-house me-2"></i>Back to Dashboard</Link>
              </div>

              <div className="text-center mt-5 pt-3">
                <p className="text-muted mb-2">Need help? Contact our support team</p>
                <div>
                  <a href="mailto:support@uplatz.com" className="text-decoration-none text-primary me-3">
                    <i className="bi bi-envelope me-1"></i>support@uplatz.com
                  </a>
                  <a href="tel:+44 7459 302492" className="text-decoration-none text-primary">
                    <i className="bi bi-telephone me-1"></i> +44 7459 302492
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      <Footer />
    </>
  );
};

export default PaymentCancelled;
